export default __webpack_public_path__ + "static/media/social_ethic.228d0fbf.png";